export default __webpack_public_path__ + "static/media/down_arrow.a05cc094.svg";